import { Model } from "@vuex-orm/core";
import Batch from "./Batch";
import { required, maxLength } from "vuelidate/lib/validators";
import User from "./User";

export class Shipping extends Model {
  static entity = "shipments";

  static $fetch() {
    return this.api().get('Shipments/')
  }
  static $get (id) {
    return this.api().get(`Shipments/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Shipments/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Shipments/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      nameIcon: this.string("mdi-truck"),
      created_on: this.string(""),
      lastmodified: this.string(""),
      ship_date: this.string(""),
      tracking: this.string(""),
      trackingIcon: this.string("fab fa-fedex"),
      address: this.string(""),
      addressIcon: this.string("fas fa-address-card"),
      phone: this.string(""),
      phoneIcon: this.string("fas fa-phone"),
      shipto: this.string(""),
      shiptoIcon: this.string("fas fa-address-book"),
      state: this.string(""),
      stateIcon: this.string("fas fa-plane"),
      customer: this.boolean(false),
      notes: this.string(""),
      account_number: this.string(""),
      children: this.hasMany(ShippingItem, "ticket_id"),
      children_misc: this.hasMany(ShippingMisc, "ticket_id"),
      requester_id: this.attr(null),
      requester: this.belongsTo(User, 'requester_id')
    };
  }
  toCreatePayload() {
    return {
      name: this.name,
      ship_date: this.ship_date,
      tracking: this.tracking,
      address: this.address,
      phone: this.phone,
      shipto: this.shipto,
      state: this.state,
      customer: this.customer,
      account_number: this.account_number,
      notes: this.notes,
      requester: this.requester_id
    };
  }
  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(48) },
        ship_date: { maxLength: maxLength(128) },
        tracking: { maxLength: maxLength(64) },
        phone: { maxLength: maxLength(64) },
        shipto: { maxLength: maxLength(128) },
        state: { required },
        notes: { maxLength: maxLength(128) },
        account_number: { maxLength: maxLength(128) },
        requester_id: { required },
      }
    };
  }
}


export class ShippingItem extends Model {
  static entity = "shippingitems";

  static $fetch() {
    return this.api().get('ShippingItems/')
  }
  static $get (id) {
    return this.api().get(`ShippingItems/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ShippingItems/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ShippingItems/${id}/`, data)
  }
  static $delete (id) {
    return this.api().delete(`ShippingItems/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      ticket: this.belongsTo(Shipping, "ticket_id"),
      ticket_id: this.attr(null),
      batch: this.belongsTo(Batch, "batch_id"),
      batch_id: this.attr(null),
      batchIcon: this.string("fas fa-cube"),
      quantity: this.string(""),
      quantityIcon: this.string("mdi-scale"),
      notes: this.string(""),
      notesIcon: this.string("mdi-message-bulleted")
    };
  }
  toCreatePayload() {
    return {
      ticket: this.ticket_id,
      batch: this.batch_id,
      quantity: this.quantity,
      notes: this.notes
    };
  }
  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
  static get validations() {
    return {
      formdata: {
        batch_id: { required },
        quantity: { maxLength: maxLength(24), required },
        notes: { maxLength: maxLength(128) }
      }
    };
  }
}


export class ShippingMisc extends Model {
  static entity = "shippingmiscs";

  static $fetch() {
    return this.api().get('ShippingMiscs/')
  }
  static $get (id) {
    return this.api().get(`ShippingMiscs/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ShippingMiscs/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ShippingMiscs/${id}/`, data)
  }
  static $delete (id) {
    return this.api().delete(`ShippingMiscs/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      ticket: this.belongsTo(Shipping, "ticket_id"),
      ticket_id: this.attr(null),
      item: this.string(""),
      quantity: this.string(""),
      quantityIcon: this.string("mdi-scale"),
      notes: this.string(""),
      notesIcon: this.string("mdi-message-bulleted")
    };
  }
  toCreatePayload() {
    return {
      ticket: this.ticket_id,
      item: this.item,
      quantity: this.quantity,
      notes: this.notes
    };
  }
  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
  static get validations() {
    return {
      formdata: {
        item: { required, maxLength: maxLength(128) },
        quantity: { maxLength: maxLength(24), required },
        notes: { maxLength: maxLength(128) }
      }
    };
  }
}

